import React from 'react';
import { IAuditoriaLancamentoCorretivoResultado } from '../interfaces/IAuditoriaLancamentoCorretivo';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaLancamentoCorretivoResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Lançamentos Corretivos (Reversão/Ajuste) no 1º Dia do Mês ou 1º Dia Útil — não é um
// tributo, é uma auditoria de governança que varre todo o livro (Ativo, Passivo, Resultado)
// procurando lançamentos de reversão/ajuste registrados no 1º dia do mês ou 1º dia útil subsequente
// (CPC 23, convergente com IAS 8). Sem aplicação de multa.
const AuditoriaResumoLancamentoCorretivo: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosCorretivos?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Lançamentos Corretivos (Reversão/Ajuste) no 1º Dia do Mês/1º Dia Útil</h3>
      <p className='text-muted'>
        Auditoria complementar — lançamentos de reversão/ajuste registrados no primeiro dia do mês (ou no primeiro
        dia útil subsequente) exigem justificativa detalhada na capa da conciliação (CPC 23 / IAS 8). Clique para ver
        a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor Identificado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_LANCAMENTO_CORRETIVO')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Lançamentos Corretivos (Reversão/Ajuste) no 1º Dia do Mês/1º Dia Útil</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} corretivo{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa aplicável (CPC 23 / IAS 8)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoLancamentoCorretivo;
